module.exports = __webpack_public_path__ + "static/img/6707_phase_function_Paper_PointsHejduk_Prediction.ad06e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6707_phase_function_Paper_PointsHejduk_Prediction.png
// module id = AGFM
// module chunks = 0